import axios from "axios";
// import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL + "/emailService";

const greetUser = (username, email, familyname) => {
    console.log(JSON.stringify({ username, email, familyname }));
    return axios.post(API_URL + "/greetUser", {
        username,
        email,
        familyname,
    });
};

export default {
    greetUser,
};
